module.exports = __webpack_public_path__ + "img/14 Animation 2-squashed.37f3ec3c.jpg";